import { connect } from 'react-redux';

import PartnershipTagsRecipientsScreen from '../components/PartnershipTagsRecipientsScreen';

const mapStateToProps = (state) => {
  return {};
};

const PartnershipTagsRecipientsScreenContainer = connect(mapStateToProps)(
  PartnershipTagsRecipientsScreen
);

export default PartnershipTagsRecipientsScreenContainer;
